import { readLocalStorage, writeLocalStorage } from "./localStoragePreference.ts";

export type Theme = "light" | "dark";

const LOCAL_STORAGE_KEY = "evalhid-theme";

/** Defaults to "light", without depending on OS preferences. */
export function readSavedTheme(): Theme {
  return readLocalStorage(LOCAL_STORAGE_KEY) === "dark" ? "dark" : "light";
}

export function saveTheme(theme: Theme): void {
  writeLocalStorage(LOCAL_STORAGE_KEY, theme);
}
